import { findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetPositions } from 'helpers/commonCodes';

export function usePositions() {
    const params = useUrlFriendlyToParameters()
    //let paramsURL = { ...params }
    const data = useGetPositions(params);
    return function (code) {
        const filter = {
            code: [code]
        }
        const description = findArray(data?.positions, filter)?.description;
        return (description);
    }
}


const getPositionOrder = (periodsOrder, posCode) => {
    return periodsOrder?.positions?.find(i => i.code === posCode)?.order;
}
//Ordena a partir del nodo props?.data?.teamAthletes
export function useTeamAthletesOrderByPositions(data, asc = true) {
    const params = useUrlFriendlyToParameters()
    const dataPosition = useGetPositions(params);
    let dataSort
    if (asc) {
        dataSort = data?.sort((a, b) => getPositionOrder(dataPosition, a?.eventUnitEntries?.find(item => item.code = 'POSITION')?.eue_value) - getPositionOrder(dataPosition, b?.eventUnitEntries?.find(item => item.code = 'POSITION')?.eue_value));
    } else {
        dataSort = data?.sort((a, b) => getPositionOrder(dataPosition, b?.eventUnitEntries?.find(item => item.code = 'POSITION')?.eue_value) - getPositionOrder(dataPosition, a?.eventUnitEntries?.find(item => item.code = 'POSITION')?.eue_value));
    }
    return (dataSort)

}